export enum BookingGuideConfirmationState {
  Showed = 1,
  NotShowed = 2,
};